module.exports = __webpack_public_path__ + "static/trophy-9b0affb8063ef323a15fd026745a7c62.svg";